import clsx from 'clsx';
import React from 'react';
import InputError from './InputError';

interface CheckboxProps {
    label: string;
    name: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
    error?: string | string[] | null;
}

const Checkbox: React.FC<CheckboxProps> = ({
    label,
    name,
    checked,
    onChange,
    disabled = false,
    className = '',
    error,
}) => {
    return (
        <div className={className}>
            <label
                className={clsx(
                    'flex items-center gap-2',
                    disabled && 'cursor-not-allowed opacity-60'
                )}
            >
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                    className="accent-theme-primary h-4 w-4 rounded border-gray-300 dark:border-neutral-600"
                />
                <span className="text-sm text-gray-700 dark:text-neutral-300">
                    {label}
                </span>
            </label>

            <InputError error={error} />
        </div>
    );
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
